import { useEffect, useState } from 'react';
import { useAccount } from '../../hooks/useAccount';
import { useAppearance } from '../../hooks/useAppearance';
import useLocales from '../../hooks/useLocales';
import { useRouter } from '../../hooks/useRouter';
import { RoutePath } from '../../pages';
import { ThemeContainer } from '../../styles';
import ConnectedWidget from '../connectedWidget';
import { ButtonContainer } from './styles';

type ConnectButtonProps = {
  label?: string;
};

const ConnectButton = (props: ConnectButtonProps) => {
  const { label } = props;
  const { isConnected, status } = useAccount();
  const { navigate } = useRouter();
  const [loading, setLoading] = useState(true);
  const { appearance } = useAppearance();
  const locales = useLocales();

  useEffect(() => {
    setLoading(false);
  }, [status]);

  if (loading) {
    return null;
  }

  return (
    <ThemeContainer $useTheme={appearance?.theme} $useMode={appearance?.mode} suppressHydrationWarning>
      {isConnected ? (
        <ConnectedWidget />
      ) : (
        <ButtonContainer
          whileHover={{
            scale: 1.05,
            boxShadow: '0px 0px 8px rgba(255,255,255,0.2)',
          }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
          }}
          onClick={() => {
            navigate(RoutePath.Signup);
          }}
        >
          {label ?? locales.connect}
        </ButtonContainer>
      )}
    </ThemeContainer>
  );
};

export default ConnectButton;
